import { createStore } from "vuex";
const fetchAll = () => {
    return fetch("/api/playlist", {
        method: "GET", 
        headers: {
            "content-type": "application/json"
        }
    })
}

const store = createStore({
    state: {
        open: false,
        closed: true,
        element: null,
        playlists: [],
        loadingPlaylist: true
    },
    mutations: {
        OPEN (state) {
            if (state.element){
                state.element.show();
                state.open = true;
                state.closed = !state.open;
            }
        },
        CLOSE (state) {
            if (state.element){
                state.element.hide()
                state.closed = true;
                state.open = !state.closed;
            }
        }
    },
    actions: {
        open(context) {
            context.commit("OPEN")
            if (!context.state.playlists.length) {
                context.state.loadingPlaylist = true
                fetchAll().then( async (result) => {
                    let data = await result.json()
                    context.state.playlists = data
                }).catch( (e) => {
                    console.log(e)
                }).finally( () =>{
                    context.state.loadingPlaylist = false
                })
            } else {
                context.state.loadingPlaylist = false
            }
        },
        async reloadPlaylists(context) {
            context.state.loadingPlaylist = true
            let response = await fetchAll()
            if (response.status==200) {
                let data = await response.json()
                context.state.playlists = data
            } else {
                console.log("Error loading Playlists")
            }
            setTimeout(() => {
                context.state.loadingPlaylist = false
            },250)
        },
        close(context) {
            context.commit("CLOSE")
        }
    }
})

export default store;